import {CircularProgress, CircularProgressProps} from '@mui/material'
import React from 'react'

export function LoaderIcon(props: CircularProgressProps) {
  return <CircularProgress {...props} />
}
